import { render, staticRenderFns } from "./MoreInformation.vue?vue&type=template&id=13caeef8&lang=pug&"
import script from "./MoreInformation.vue?vue&type=script&lang=js&"
export * from "./MoreInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports